import React from "react";
import { FaEnvelope, FaLinkedin } from "react-icons/fa";

import {
  CopyrightText,
  FooterAnchor,
  FooterContainer,
  FooterLink,
  FooterLinks,
} from "./Footer.styled";

const Footer = () => {
  return (
    <>
      <FooterContainer>
        <CopyrightText>
          © 2025 Open For Conversation. All Rights Reserved
        </CopyrightText>
        <FooterLinks>
          <FooterLink>
            <FaEnvelope />
            <FooterAnchor
              href="mailto:openforconversationapp@gmail.com"
              rel="noreferrer"
            >
              Email us!
            </FooterAnchor>
          </FooterLink>
          <FooterLink>
            <FaLinkedin />
            <FooterAnchor
              href="https://www.linkedin.com/company/openforconversation"
              rel="noreferrer"
            >
              LinkedIn
            </FooterAnchor>
          </FooterLink>
        </FooterLinks>
      </FooterContainer>
    </>
  );
};

export default Footer;
